import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SubscriptionsService} from 'src/app/services/subscriptions.service';
import {LetterSubscriptionDialogComponent} from '../dialogs/letter-subscription-dialog/letter-subscription-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {LetterSubscriber} from 'src/app/models/letter-subscriber';
import {FormGroup} from '@angular/forms';
import {LetterSubscriberService} from 'src/app/services/letter-subscriber.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {Guid} from 'guid-typescript';
import {EmailService} from 'src/app/services/email.service';
import {ContextService} from 'src/app/services/context.service';
import {FileService} from 'src/app/services/file.service';

@Component({
  selector: 'app-letters-subscriptions',
  templateUrl: './letters-subscriptions.component.html',
  styleUrls: [ './letters-subscriptions.component.scss' ]
})
export class LettersSubscriptionsComponent implements OnInit {

  public isCongress: boolean;
  public uid: string;
  public title: any;

  public letterSubscriberSelected: any;
  public subscriptions: any[] = [];

  public arrayLettersSubscribers: LetterSubscriber[];

  public lettersSubscribersDataSource: MatTableDataSource<any>
  public displayLettersSubscribersColumns: string[] = [ 'name', '_type', 'edit', 'delete' ];

  constructor (
    private _contextService: ContextService,
    public _subscriptionsService: SubscriptionsService,
    private _letterSubscriberService: LetterSubscriberService,
    private _spinnerService: SpinnerService,
    private _dialog: MatDialog,
    private _activeRoute: ActivatedRoute,
    private _snackBar: SnackBarIconService,
    private _emailService: EmailService,
    private _fileService: FileService,
  ) { }

  ngOnInit () {
    this._activeRoute.params.subscribe(params => {
      this.isCongress = params[ 'isCongress' ] === 'true';
      this.uid = params[ 'uid' ];
      this.selectContext()
    })

  }

  async selectContext () {

    if (this.isCongress) {
      const master: any = await this._contextService.getMasterEvent(this.uid);
      this.title = master.name;
    } else {
      const event: any = await this._contextService.getEvent(this.uid);
      this.title = event.name;
    }

    this.loadLettersByContext(this.uid)
    this.loadSubscriptions(this.isCongress, this.uid)

  }

  async loadSubscriptions (isCongress: any, context_id: any) {
    const waiting = this._spinnerService.show();
    this._subscriptionsService.subscriptionLetterDataSource = null;
    this.subscriptions = await this._subscriptionsService.getSubscriptionsByContext(isCongress, context_id)
    //console.log("this.subscriptions: " + JSON.stringify(this.subscriptions))
    waiting.close()
  }

  loadLettersByContext (context_id) {
    this._letterSubscriberService.selectByContext(context_id)
      .subscribe((result) => {
        this.arrayLettersSubscribers = []
        result.forEach((item) => {
          const entity = this.makeLetter(item)
          this.arrayLettersSubscribers.push(entity);
        })
        this.lettersSubscribersDataSource = new MatTableDataSource(this.arrayLettersSubscribers);
        return;
      })
  }

  makeLetter (item) {
    return {
      id: item.payload.doc.id,
      name: item.payload.doc.data().name,
      subject: item.payload.doc.data().subject,
      type: item.payload.doc.data().type,
      text: item.payload.doc.data().text,
      text_back: item.payload.doc.data().text_back,
      context_id: item.payload.doc.data().context_id,
      // event_id: item.payload.doc.data().event_id,
      // event_name: item.payload.doc.data().event_name,
      image_url: item.payload.doc.data().image_url,
      deleted: item.payload.doc.data().deleted,
    }
  }

  deleteLetterSubscriber (element) {
    //console.log("deleteLetterSubscriber: " + element.id);
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta carta?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._letterSubscriberService.deleteLetter(element.id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete letter subscriber: ")} // + error.message)}
          )

      }
    })
  }

  openLetterSubscribersDialog (element: LetterSubscriber) {

    let data: LetterSubscriber;

    if (element) {
      data = element;
    } else {
      data = new LetterSubscriber()
      data.context_id = this.uid;
    }

    let dialogRef = this._dialog.open(LetterSubscriptionDialogComponent, {
      width: '920px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];
        const image: FormGroup = response[ 2 ];
        const formData: any = form.getRawValue();

        const entity = this._letterSubscriberService.createLetter(formData);

        if (image) {
          this._letterSubscriberService.objectImage = image
        } else {
          this._letterSubscriberService.objectImage = null;
        }

        if (actionType == 'insert') {
          // console.log("insert")
          this._letterSubscriberService.insert(entity)
            .then((result) => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
              entity.id = result.id;
              if (image) {
                this._letterSubscriberService.update(entity)
                  .then(() => {
                    this._letterSubscriberService.objectImage = null;
                  })
              }
            })
            .catch((err: any) => {
              console.log("erro") //err.message
            })
        }

        if (actionType == 'update') {
          // console.log("update")
          this._letterSubscriberService.update(entity)
            .then(() => {
              this._letterSubscriberService.objectImage = null;
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro") //err.message
            })

        }

      })
  }

  async letterSubscriberSelectedChange (event) {
    const waiting = this._spinnerService.show();
    this.letterSubscriberSelected = event;
    await this._subscriptionsService.getLettersSentByContext(this.uid, this.letterSubscriberSelected, this.subscriptions);
    waiting.close();
  }

  async sendSubscribersEmail () {

    const waiting = this._spinnerService.show();
    const letterResult = await this._letterSubscriberService.getById(this.letterSubscriberSelected).toPromise();

    let emailLetter: LetterSubscriber = {
      "id": letterResult.id,
      "name": letterResult.data().name,
      "subject": letterResult.data().subject,
      "type": letterResult.data().type,
      "text": letterResult.data().text,
      "text_back": letterResult.data().text_back,
      "context_id": letterResult.data().context_id,
      "image_url": letterResult.data().image_url,
      "deleted": letterResult.data().deleted,
    };

    const data = this._subscriptionsService.subscriptionLetterDataSource.data;
    // console.log(JSON.stringify(data))

    data.forEach((item) => {

      if (item.selected) {

        const img = "<img style='max-height: 150px;' src='" + emailLetter.image_url + "'/>"
        emailLetter.text = emailLetter.text.replace("[email_image]", img)
        emailLetter.text = emailLetter.text.replace("[event_name]", item.product_name)

        let email: any = {
          "member_id": item.member_id,
          "member_name": item.member_name,
          "member_email": item.member_email,
          "letter_subscriber": this.letterSubscriberSelected
        }

        let textData = emailLetter.text
        textData = textData.replace("[member_name]", email.member_name);
        textData = textData.replace("[member_email]", email.member_email);

        let textBackData: string = "";
        if (emailLetter.type == "0") {
          emailLetter.text_back = emailLetter.text_back.replace("[event_name]", item.product_name)
          textBackData = emailLetter.text_back
          textBackData = textBackData.replace("[member_name]", email.member_name);
          textBackData = textBackData.replace("[member_email]", email.member_email);
        }

        const key: any = Guid.create()
        const link = "https://sbccv-proj.web.app/subscribers/" + key

        textData = textData.replace("[link_email]", "<a href='" + link + "'>CLIQUE AQUI</a>");

        // console.log(JSON.stringify(textData))

        const emailLetterSent = {
          "id": key.value,
          "context_id": this.uid,
          "letter_id": email.letter_subscriber,
          "letter_name": emailLetter.name,
          "letter_type": emailLetter.type,
          "letter_link": link,
          "product_id": item.product_id,
          "product_name": item.product_name,
          "member_id": email.member_id,
          "member_name": email.member_name,
          "member_email": email.member_email,
          "subject": emailLetter.subject,
          "text": textData,
          "text_back": textBackData,
          "sentDate": new Date(),
          "refuse": false
        }
        
        console.log("emailLetterSent: " + JSON.stringify(emailLetterSent));
        
        this._letterSubscriberService.insertEmailSent(key.value, emailLetterSent)
          .then(() => {

            console.log("enviado: " + emailLetterSent.member_email);// )
            this.sendEmail(emailLetterSent);

          })
            

      }
    })

    //
    waiting.close();
    //
  }

  sendEmail (emailLetterSent) {
    this._emailService.sendStandardEmail({
      'subject': emailLetterSent.subject,
      'html': emailLetterSent.text,
      'from': "SBCCV <cientifico@sbccv.org.br>",
      'to': emailLetterSent.member_email,
      'bcc': "cientifico@sbccv.org.br" // email.otero@gmail.com, 
    })
      .then(() => {
        console.log("enviado: ") // + emailLetterSent.member_email)
      })
      .catch(() => {
        console.log("send email error")
      })
  }

  deleteEmailLetter (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.member_name + "<br><br>Excluir este email?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._letterSubscriberService.deleteSent(element.id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete room error: ")} // + error.message)}
          )

      }
    })
  }

  async exportToCSV () {
    const data = this._subscriptionsService.subscriptionLetterDataSource.data;
    const headers = [ 'Inscrito', 'Produto', 'Email', 'Envio', 'Resposta', 'Aceite' ];
    const csvContent = data.map((element: any) => {
      const item = {
        Inscrito: element.member_name,
        Produto: element.product_name,
        Email: element.member_email,
        Envio: this.formatDate(element.sentDate),
        Resposta: this.formatDate(element.responseDate),
        Aceite: element.refuse ? "Recusa" : "Aceita"
      };
      return Object.values(item).join(';');
    });

    const csvArray = [ headers.join(';'), ...csvContent ].join('\n');
    const blob = new Blob([ `\uFEFF${ csvArray }` ], {type: 'text/csv;charset=utf-8;'});
    this._fileService.saveFile(blob, this.uid + ".csv");
  };

  formatDate (date: Date) {
    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

}

